// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"12d1145d","288":"e1cfb285","798":"7a1cf399","966":"f8755bbb","975":"89be737f","995":"9e2ee5b9"}[chunkId] + ".chunk.js";
};